import { LunaStreamsClient } from '../luna-streams';

export class LunaApiStreamsClient extends LunaStreamsClient {
  constructor(baseUrl = '', apiVersion = '') {
    super(baseUrl, apiVersion);
  }

  // НЕОБХОДИМО ЧТО БЫ ПРОПУСТИТЬ ЗАПРОСЫ НА СТРИМЫ,
  // ТК healthcheck НЕТ В ПЛАГИНАХ - ЛОВИМ 404
  healthcheck() {
    return this;
  }
}
